import { Box, Divider, Group, Stack } from "@mantine/core"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { AgencyOperationsAdminThreadMessages } from "./messages/AgencyOperationsAdminThreadMessages"
import { AgencyOperationsAdminThreadPreview } from "src/components/agency/operations/administrator/threads/AgencyOperationsAdminThreadPreview"

export function AgencyOperationsAdminThread() {

    const { currentItem } = useAppState(state => state.threads)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.id}`}
                    renderAction={
                        <Group gap="sm">

                        </Group>
                    }
                />
            }
        >

            <Stack gap="sm">
                <AgencyOperationsAdminThreadPreview />
                <Divider
                    my="0"
                    variant="dashed"
                    labelPosition="left"
                    label={<Box ml={5}>Messages</Box>}
                />
                <AgencyOperationsAdminThreadMessages />
            </Stack>

        </PageLayout>
    )

}